import React, { useState } from 'react';
import { Outlet, useNavigate, Link, useLocation } from 'react-router-dom';

import axios from 'axios';
import { remove } from '../utils/auth';

import '../index.css';

export default function Header(props) {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const [hideValue, setHideValue] = useState('hidden');
  const navigate = useNavigate();
  const [url2, setUrl2] = useState('');
  const [text, setText] = useState('Search');
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div>
      {/* <!-- start header  --> */}
      <header className="z-10">
        <div class="container">
          <div class="row">
            <div class="col-md-3 col-8">
              <div class="logo">
                <a href="/" className="mt-2">
                  <img
                    src="/img/manuelextra.jpg"
                    alt="logo"
                    className="rounded"
                    style={{ width: '4em', height: '4em' }}
                  />
                </a>
              </div>
            </div>
            <div class="col-md-9 col-4">
              <ul id="menu_items" class="menu_items mt-3">
                <li class="nav-item">
                  <a
                    href="#top"
                    class="active menu_item nav-link slide-horizontal"
                    data-splitting
                  >
                    Home
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="#about"
                    class="menu_item nav-link slide-horizontal"
                    data-splitting
                  >
                    About
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="#service"
                    class="menu_item nav-link slide-horizontal"
                    data-splitting
                  >
                    Service
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="#works"
                    class="menu_item nav-link slide-horizontal"
                    data-splitting
                  >
                    Works
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="#testimonial"
                    class="menu_item nav-link slide-horizontal"
                    data-splitting
                  >
                    Testimonial
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="#contact"
                    class="menu_item nav-link slide-horizontal"
                    data-splitting
                  >
                    Contact
                  </a>
                </li>
              </ul>
              {/* <!-- responsive menu btn --> */}
              <div class="nav-btn mt-3 md:mt-0">
                <button
                  type="button"
                  class="inline-flex items-center p-2 ml-3 text-sm text-gray-200 rounded-lg md:hidden hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                  onClick={() =>
                    setHideValue(hideValue === 'hidden' ? '' : 'hidden')
                  }
                >
                  <span class="sr-only">Open main menu</span>
                  <svg
                    class="w-6 h-6"
                    aria-hidden="true"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <nav
          className={`bg-black border-gray-700 z-20 sm:px-4 w-full rounded dark:bg-gray-900`}
          style={{ marginTop: '-10px' }}
        >
          <div class="flex flex-wrap items-center justify-between mx-auto">
            <div className={`${hideValue} w-full md:block md:w-auto`}>
              <ul class="flex flex-col bg-gray-700 md:hidden md:space-x-3 my-0 md:mt-0 md:text-sm md:font-medium md:border-0 md:bg-black dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
                <li style={{ paddingTop: '-28px' }}>
                  <a
                    href="/"
                    onClick={() => setHideValue('hidden')}
                    class="block pl-3 pr-4 text-white hover:bg-gray-500 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
                    aria-current="page"
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a
                    href="/#about"
                    onClick={() => setHideValue('hidden')}
                    class="block pl-3 pr-4 text-white hover:bg-gray-500 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
                  >
                    About
                  </a>
                </li>
                <li>
                  <a
                    href="/#service"
                    onClick={() => setHideValue('hidden')}
                    class="block pl-3 pr-4 text-white hover:bg-gray-500 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
                  >
                    Service
                  </a>
                </li>
                <li>
                  <a
                    href="/#works"
                    onClick={() => setHideValue('hidden')}
                    class="block pl-3 pr-4 text-white hover:bg-gray-500 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
                  >
                    Works
                  </a>
                </li>
                <li>
                  <a
                    href="/#testimonial"
                    onClick={() => setHideValue('hidden')}
                    class="block pl-3 pr-4 text-white hover:bg-gray-500 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
                  >
                    Testimonial
                  </a>
                </li>
                <li>
                  <a
                    href="/#contact"
                    onClick={() => setHideValue('hidden')}
                    class="block pl-3 pr-4 text-white hover:bg-gray-500 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
}
